export function formatCurrency(amount: number, penceDigits = 2) {
    return `${Intl.NumberFormat("en-GB",
        {
            style: "currency",
            minimumFractionDigits: penceDigits,
            maximumFractionDigits: penceDigits,
            currency: "GBP",
        },
    ).format(amount)}`;
}
